import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String
  }

  connect () {
    const modal = this.element.closest('.modal')
    if (modal && window.bootstrap && window.bootstrap.Modal) {
      let bootstrapModal = window.bootstrap.Modal.getInstance(modal)

      if (!bootstrapModal) bootstrapModal = new bootstrap.Modal(modal)

      bootstrapModal.hide()
    }

    setTimeout(() => {
      window.location.href = this.urlValue
    }, 200)
  }
}
